module.exports = __webpack_public_path__ + "img/full5-min.f2b281de.png";